<template>
  <el-card>
    <div style="width: 500px">
      <el-form label-width="180px">
        <el-row>
          <el-form-item label="市场：">
            白糖
          </el-form-item>
          <el-form-item label="银行渠道：">
            白糖-中信银行
          </el-form-item>
          <el-form-item label="附属账号：">
            {{subAccount.exAccountNo}}
          </el-form-item>
          <el-form-item label="附属账户名：">
            {{subAccount.exAccountName}}
          </el-form-item>
          <el-form-item label="附属账户金额：">
            {{subAccount.amount | thousandMark}}
          </el-form-item>
          <el-form-item label="转入到账号：">
            <el-select v-model="recvAccNo" placeholder="请选择" @change="handleSelect">
              <el-option v-for="(item, index) in restaurants" :key="index" :label="item.value +' '+ item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额：">
            <el-input v-model="tranAmt" style="width: 210px" placeholder="请输入金额" @input="checkType"></el-input>
          </el-form-item>
           <el-form-item label="支付密码：">
            <el-input v-model='password' :type="isDesen ? 'password' : ''" placeholder='输入6位数字' class="input" @input="checkPass(password, 'password')"></el-input>
            <div @click="select" class="tips">
              <img src="@/assets/password_hide.png" alt="" class="password" v-if="isDesen">
              <img src="@/assets/password_visual.png" alt="" class="password" v-if="!isDesen">
            </div>
          </el-form-item>

          <span class="forget-password" @click="forgetPass">
            忘记密码
          </span>
        </el-row>
        <div class="text-c m-t-20">
          <el-button size="small" class='sure' type="primary" @click="sure" :loading="loading">确 定</el-button>
        </div>
      </el-form>
    </div>
    <forget-pass @closeMain="closeMain" v-if="isDisplay" editType='2'></forget-pass>
    <set-pass @closeMain="closeMain" v-if="isSetDisplay" :userId="userId"></set-pass>
  </el-card>
</template>

<script>
import Cookie from 'js-cookie'
import api from '@/api'
import CryptoJS from 'crypto-js'
import forgetPass from '@/components/forget-pass'
import setPass from '@/components/set-pass'
import { filterDecAmount } from '@/utils/util'
export default {
  name: 'suger-detail',
  components: {
    forgetPass,
    setPass
  },
  data () {
    return {
      loading: false,
      subAccount: {},
      payWay: '1',
      accountList: [],
      tranAmt: '',
      password: '',
      recvAccNo: '',
      recvAccNoAccount: '',
      bankAccountNo: '',
      restaurants: [],

      isDisplay: false,
      isSetDisplay: false,
      // 密码脱敏显示
      isDesen: true,
      btnOff: true,

      // 用户id
      userId: Cookie.getJSON('AppUserInfo').userId,

      // 前端校验
      createRules: [
        { name: 'recvAccNo', message: '请输入收款方账号' },
        { name: 'tranAmt', message: '请填写金额' },
        { name: 'password', message: '请输入支付密码' },
      ],
    }
  },
  filters: {
    amount (a) {
      var f1 = parseFloat(a)
      if (isNaN(f1)) {
        return
      }
      var f2 = Math.round(a * 100) / 100
      var s = f2.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + 2) {
        s += '0'
      }
      return s + '元'
    }
  },
  watch: {
    tranAmt () {
      if (this.btnOff) {
        this.tranAmt = ''
        this.password = ''
        this.btnOff = false
      }
    }
  },
  created () {
    // 查询附属户走和查余额一共两套
    // 一套全部查恒生的
    // 一套查资金的
    api.myAccount.querySubBankAccountInfo().then(res => { // 查询附属账户
      this.queryGoodsAccountInfo() // 拉取可提现银行卡
      if (res.data.marketId !== '000') {
        this.getSubAccount()
      } else { // 白糖市场查询余额用恒生接口
        this.subAccount = res.data || {}
        this.subAccount.exAccountNo = res.data.subBankAccount
        this.subAccount.exAccountName = res.data.subBankAccountName
        api.myAccount.querySubBankAccountBalance({
          bankProCode: res.data.bankProCode,
          subBankAccount: res.data.subBankAccount
        }).then((result) => {
          this.$set(this.subAccount, 'amount', result.data.canUseBalance) // 拿到账户余额
        })
      }
    })
  },
  methods: {
    // 金额校验
    checkType (v) {
      this.tranAmt = filterDecAmount(v)
    },

    // 密码脱敏显示
    select () {
      this.isDesen = !this.isDesen
    },

    // 判断是否是数字
    checkPass (v, k) {
      if (!isNaN(v)) {
        this[k] = v
      } else {
        this[k] = ''
      }
    },

    // 获取附属户
    async getSubAccount () {
      let param = {
        currentNo: 1,
        pageSize: 10,
        marketId: '000',
        baseAccountTypeList: ['SUB_ACCOUNT']
      }
      let res = await api.myAccount.zbAccountList(param)
      let arr = []
      res.data.forEach((item) => {
        if (item.baseAccountType === 'SUB_ACCOUNT') {
          arr.push(item)
        }
      })
      this.subAccount = arr[0] || {} // 拿第一个附属户（正常情况下只会有一个附属户）
      this.isSugerOperation = true
      this.getAmount()
    },
    // 货款余额查询
    async getAmount () {
      if (!this.subAccount.baseAccountNo) return
      const res = await api.myAccount.baseAccountBalance(JSON.stringify(this.subAccount.baseAccountNo))
      this.$set(this.subAccount, 'amount', res.data.amount)
    },

    // 确定
    async sure () {
      let param = {
        marketId: '000',
        channelId: 'CITIC',
        tranAmt: this.tranAmt,
        recvAccNo: this.recvAccNoAccount,
        password: this.encryptByAes(this.password)
      }
      if (this.tranAmt > this.subAccount.amount) {
        this.$message.error('划转金额不能大于账户金额')
        return
      }
      if (this.tranAmt <= 0) {
        this.$message.error('划转金额不能小于等于0')
        return
      }
      if (this.$utils.checkEmptyRules(param, this.createRules)) {
        return
      }

      const data = (await api.myAccount.checkHasPsw({ userId: this.userId })).data
      // 已经设置了支付密码
      if (data === '1') {
        this.loading = true
        api.myAccount.loanInAndOut(param).then((res) => {
          if (res.succeed) {
            this.tranAmt = ''
            this.recvAccNo = ''
            this.recvAccNoAccount = ''
            this.password = ''
            this.$message.success('成功')
            this.loading = false
          } else {
            this.$message.error('失败')
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        })
      }
      // 没有设置支付密码
      if (data === '0') {
        this.$confirm('您还没有设置支付密码, 是否设置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isSetDisplay = true
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消设置'
          })
        })
      }
    },

    // 获取货款信息列表
    queryGoodsAccountInfo () {
      api.myAccount.queryGoodsAccountInfo({
        marketId: '000'
      }).then((res) => {
        if (res.succeed) {
          this.accountList = res.data
          let restaurants = this.accountList.map((item, idx) => {
            return {
              'value': item.bankAccount,
              'account': item.account,
              'id': idx,
              'ids': item.id,
              'name': item.accountName
            }
          })
          this.restaurants = restaurants
        } else {
          this.$message.error('请求失败')
        }
      })
    },

    // 选中
    handleSelect (idx) {
      this.recvAccNo = this.restaurants[idx].value
      this.recvAccNoAccount = this.restaurants[idx].ids
      if (this.payWay === '0') {
        this.getAmount()
      }
    },

    // 密码加密
    encryptByAes (psw) {
      let key = CryptoJS.enc.Utf8.parse('APP7apecSQznwPWD') // 秘钥
      let iv = CryptoJS.enc.Utf8.parse('307znw65426apecb') // 偏移量
      let srcs = CryptoJS.enc.Utf8.parse(psw)
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.ciphertext.toString().toUpperCase()
    },

    // 忘记密码
    forgetPass () {
      this.isDisplay = true
    },

    closeMain (e) {
      this.isDisplay = false
      this.isSetDisplay = false
    }
  },
}
</script>

<style lang="scss" scoped>
.text-c {
  padding-bottom: 50px;
}
.input {
  width: 210px;
  height: 30px;
  line-height: 30px;
}
.password {
  width: 22px;
  height: 10px;
  float: left;
}
.tips {
  position: absolute;
  top: 16px;
  left: 180px;
  width: 25px;
  height: 25px;
}
.gobal-form{
  .el-input, .el-input__inner{
    width:217px !important;
  }
  div.input-val{
    display:inline-block;
    width:217px;
  }
}
.forget-password{
  cursor: pointer;
  color: blue;
  text-decoration: underline;
  font-size: 12px;
  margin-left: 180px;
}
.next {
  margin: 0 0 0 150px;
}
.sure {
  margin-left: -75px;
}
.recvAccNo {
  display: block;
  margin-left: -38px;
  width: 235px;
}
.recvAccNo li {
  list-style: none;
  border: 1px solid red;
  text-align: left;
  height: 30px;
  line-height: 30px;
}
</style>
